import React from 'react';
import './Footer.css';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { FaBars, FaTimes, FaWhatsapp } from 'react-icons/fa'; // Import WhatsApp, hamburger, and close icons


const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-links">
          <div className="footer-link-section">
            <h4>About Us</h4>
            <a href="/about">OJ Mechanisms</a>
            <a href="/contact">Contact Us</a>
            <a href="/cars">Vehicles</a>
            <a href="/bikes">Bicycles</a>
            <a href="/terms">Car Sourcing</a>
            <p>Email: info@ojmechanisms.com</p>
            <p>Nairobi, Kenya</p>

            
          </div>
          <div className="footer-link-section">
            <h4>Support</h4>
            <a href="/faq">FAQ</a>
            <a href="/team">Meet the Team</a>
            <a href="/terms">Terms of Service</a>
            <p>+254742077050</p>
            
          </div>
          <div className="footer-link-section">
            <h4>Follow Us</h4>
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebook /> Facebook</a>
            <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer"><FaTwitter /> Twitter</a>
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer"><FaInstagram /> Instagram</a>
            <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedin /> LinkedIn</a>
            <a href="https://wa.me/254792454764" target="_blank" rel="noopener noreferrer" className="whatsapp-link"><FaWhatsapp />Whatsapp</a>
          </div>
          <div className="footer-link-section">
            <h4>Newsletter</h4>
            <form className="newsletter-form">
              <input type="email" placeholder="Your email address" required />
              <button type="submit">Subscribe</button>
            </form>
          </div>
        </div>
        <center>
        <div className="footer-info">
          <p>© {new Date().getFullYear()} <a href="https://don-gamma.vercel.app/">Donmureithi</a>. All rights reserved.</p>
        </div>

        </center>
      </div>
    </footer>
  );
};

export default Footer;
